import React from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import { Row, Col } from "react-bootstrap";

import CustomerSelect from "../../common/CustomerSelect";
import CallTypeSelect from "../../common/CallTypeSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import ProjectSelect from "../../common/ProjectSelect";
import UserSelect from "../../common/UserSelect";
import ProjectOwnerSelect from "../../common/ProjectOwnerSelect";
import ProjectCategorySelect from "../../common/ProjectCategorySelect";
import ProjectStatusSelect from "../../common/ProjectStatusSelect";

import ReportFilters from "../ReportFiltersComponent";

const ProjectSummaryByCustomerFilters = ({
  onChange,
  filters,
  projects,
  setProjects,
  fetchData,
  handleResetFilters,
  loading,
  onExportClick,
  exportDisabled
}) => (
  <Formsy>
    <ReportFilters
      onFetchClick={fetchData}
      onResetClick={handleResetFilters}
      title="Project Summary By Customer"
      loading={loading}
      csvExportAvailable
      onCSVExport={onExportClick}
      exportDisabled={loading || exportDisabled}
    >
      <Row>
        <Col md={3}>
          <ProjectCategorySelect
            placeholder="Select"
            label="Category"
            isMulti
            value={filters.filtered.category}
            onChange={onChange("category")}
          />
        </Col>
        <Col md={3}>
          <ProjectOwnerSelect
            selectedDepartment={filters.filtered.department}
            placeholder="Select"
            label="Owner"
            name="project_manager"
            isMulti
            value={filters.filtered.project_manager || []}
            projects={projects}
            onChange={onChange("project_manager")}
          />
        </Col>
        <Col md={3}>
          <CustomerSelect
            placeholder="Select"
            label="Customer"
            isMulti
            value={filters.filtered.customer || []}
            onChange={(e) => onChange("customer")(e || [])}
          />
        </Col>
        <Col md={3}>
          <ProjectStatusSelect
            label="Status"
            isMulti
            placeholder="Select"
            value={filters.filtered.project_status || []}
            onChange={onChange("project_status")}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <DepartmentSelect
            placeholder="Select"
            label="Department"
            isMulti
            value={filters.filtered.department || []}
            onChange={(e) => onChange("department")(e || [])}
          />
        </Col>
        <Col md={3}>
          <CallTypeSelect
            label="Project Type"
            placeholder="Select"
            isMulti
            value={filters.filtered.call_type || []}
            onChange={onChange("call_type")}
          />
        </Col>
        <Col md={3}>
          <ProjectSelect
            placeholder="Select"
            label="Project"
            isMulti
            onChange={onChange("projects")}
            loadProjects={setProjects}
            selectedCustomers={
              filters.filtered.customer ? filters.filtered.customer : null
            }
            value={filters.filtered.projects || []}
          />
        </Col>
        <Col md={3}>
          <UserSelect
            selectedDepartment={filters.department}
            placeholder="Select"
            label="Resource 1"
            name="resource1"
            projects={projects}
            isMulti
            value={filters.filtered.resource1 || []}
            onChange={onChange("resource1")}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <UserSelect
            selectedDepartment={filters.department}
            placeholder="Select"
            label="Resource 2"
            name="resource2"
            projects={projects}
            isMulti
            value={filters.filtered.resource2 || []}
            onChange={onChange("resource2")}
          />
        </Col>
      </Row>
    </ReportFilters>
  </Formsy>
);
ProjectSummaryByCustomerFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object,
  setProjects: PropTypes.func,
  projects: PropTypes.array,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  onExportClick: PropTypes.func,
  exportDisabled: PropTypes.bool
};

export default ProjectSummaryByCustomerFilters;
